import { useWindowWidth } from '@react-hook/window-size';
import { Breakpoints, BreakpointWrapper, Container } from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { updateMinHeight, useMaxElementsHeight } from 'src/feature-app/hooks';
import { OfferView375, OfferView560, OfferViewDesktop } from 'src/feature-app/offersViews';
import { CarlineWithOffers } from 'src/types';

interface OfferContainerProps {
  carline: CarlineWithOffers;
  setShowOfferToFalse: () => void;
  showOffer: boolean;
  unSelectCarline?: () => void;
  showCard: boolean;
  mode?: string;
  id?: string;
  auxDesktopOfferClassName?: string;
  parentId?: string;
}

export function OfferContainer(props: OfferContainerProps) {
  const {
    carline,
    setShowOfferToFalse,
    showOffer,
    unSelectCarline,
    showCard,
    id,
    auxDesktopOfferClassName,
  } = props;

  const { maxHeight } = useMaxElementsHeight('carline-model-cuotainfo');
  const width = useWindowWidth();

  useEffect(() => {
    updateMinHeight(maxHeight, 'carline-model-set-minheight');
  }, [maxHeight, width]);

  return (
    <div style={{ width: '100%' }} id={id}>
      <Container stretchContent>
        <BreakpointWrapper max={Breakpoints.b560}>
          <OfferView375
            carline={carline}
            showOffer={showOffer}
            setShowOfferToFalse={setShowOfferToFalse}
            unSelectCarline={unSelectCarline}
            showCard={showCard}
          />
        </BreakpointWrapper>
        <BreakpointWrapper min={Breakpoints.b560} max={Breakpoints.b960}>
          <OfferView560
            carline={carline}
            setShowOfferToFalse={setShowOfferToFalse}
            unSelectCarline={unSelectCarline}
            offersId={id}
            showCard={showCard}
            auxDesktopOfferClassName={auxDesktopOfferClassName}
          />
        </BreakpointWrapper>
        <BreakpointWrapper min={Breakpoints.b960}>
          <OfferViewDesktop
            carline={carline}
            setShowOfferToFalse={setShowOfferToFalse}
            unSelectCarline={unSelectCarline}
            offersId={id}
            showCard={showCard}
            auxDesktopOfferClassName={auxDesktopOfferClassName}
          />
        </BreakpointWrapper>
      </Container>
    </div>
  );
}
